/**
 * Map timesheet `user_id` (Django User pk) to roster display names.
 * Also aliases Member.pk when it differs from User.pk (historic data issue).
 */

export function resolveTeamRowUserId(row) {
  if (!row || typeof row !== "object") return null;
  const nested = row.user;
  if (typeof nested === "number" && nested > 0) return nested;
  if (typeof nested === "string" && /^\d+$/.test(nested.trim())) {
    return Number(nested.trim());
  }
  if (nested && typeof nested === "object" && nested.id != null) {
    const id = Number(nested.id);
    if (Number.isFinite(id) && id > 0) return id;
  }
  const explicit = Number(row.user_id);
  if (Number.isFinite(explicit) && explicit > 0) return explicit;
  return null;
}

export function normalizeTimesheetRowUserId(row) {
  if (!row || typeof row !== "object") return null;
  const raw = row.user_id;
  if (raw != null && typeof raw === "object" && raw.id != null) {
    const id = Number(raw.id);
    if (Number.isFinite(id) && id > 0) return id;
  }
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) return n;
  return null;
}

/**
 * @returns {Record<number, { fullName: string, userId: number, memberId: number|null }>}
 */
export function buildTimesheetRosterLookup(teamRows) {
  const byKey = {};
  const attach = (key, fullName, djangoUserId, memberPk) => {
    const k = Number(key);
    if (!Number.isFinite(k) || k <= 0) return;
    const name = String(fullName || "").trim() || `User ${djangoUserId || k}`;
    const entry = {
      fullName: name,
      userId: djangoUserId != null ? djangoUserId : k,
      memberId: memberPk != null ? memberPk : null,
    };
    byKey[k] = entry;
  };

  (teamRows || []).forEach((row) => {
    const djangoUserId = resolveTeamRowUserId(row);
    const memberPk = Number(row.id);
    const fullName = row.full_name || row.name || "";
    if (djangoUserId != null) {
      attach(djangoUserId, fullName, djangoUserId, memberPk);
    }
    if (Number.isFinite(memberPk) && memberPk > 0) {
      attach(memberPk, fullName, djangoUserId, memberPk);
    }
  });

  return byKey;
}

export function displayNameForTimesheetUserId(lookup, userId) {
  const uid = Number(userId);
  if (!Number.isFinite(uid) || uid <= 0) return "";
  const entry = lookup && lookup[uid];
  return entry ? entry.fullName : `User ${uid}`;
}

export function djangoUserIdForTimesheetRow(lookup, row) {
  const fromRow = normalizeTimesheetRowUserId(row);
  if (fromRow != null) return fromRow;
  return null;
}
